<template>
  <div>
    <h1>PEINTURES</h1>
    <v-lightbox :images="imageArrayObjects[0]" :options="options" :currentImageIndex="currentImageIndex[0]" :toggleLightbox="lightboxState[0]" @toggleLightbox="(state) => {toggleCurrentLightBox(0, state)}"></v-lightbox>
    <v-lightbox :images="imageArrayObjects[1]" :options="options" :currentImageIndex="currentImageIndex[1]" :toggleLightbox="lightboxState[1]" @toggleLightbox="(state) => {toggleCurrentLightBox(1, state)}"></v-lightbox>
    <v-lightbox :images="imageArrayObjects[2]" :options="options" :currentImageIndex="currentImageIndex[2]" :toggleLightbox="lightboxState[2]" @toggleLightbox="(state) => {toggleCurrentLightBox(2, state)}"></v-lightbox>
    <v-lightbox :images="imageArrayObjects[3]" :options="options" :currentImageIndex="currentImageIndex[3]" :toggleLightbox="lightboxState[3]" @toggleLightbox="(state) => {toggleCurrentLightBox(3, state)}"></v-lightbox>
    <v-lightbox :images="imageArrayObjects[4]" :options="options" :currentImageIndex="currentImageIndex[4]" :toggleLightbox="lightboxState[4]" @toggleLightbox="(state) => {toggleCurrentLightBox(4, state)}"></v-lightbox>
    <v-tabs :tabs="tabs" @setActiveTab="(slug) => { setActiveTab(slug) }" :active="getActiveTab()">
      <div :slot="tabs[0]" class="gallery">
        <div v-for="(image, index) in $images['works1980-1990'].preview" :key="image.name" class="gallery-preview" @click="openLightbox(0, index)">
          <img :src="require('../' + image)" alt="">
        </div>
      </div>
      <div :slot="tabs[1]" class="gallery">
        <div v-for="(image, index) in $images['works1991-1995'].preview" :key="image.name" class="gallery-preview" @click="openLightbox(1, index)">
          <img :src="require('../' + image)" alt="">
        </div>
      </div>
      <div :slot="tabs[2]" class="gallery">
        <div v-for="(image, index) in $images['works1996-1999'].preview" :key="image.name" class="gallery-preview" @click="openLightbox(2, index)">
          <img :src="require('../' + image)" alt="">
        </div>
      </div>
      <div :slot="tabs[3]" class="gallery">
        <div v-for="(image, index) in $images['works2000-2005'].preview" :key="image.name" class="gallery-preview" @click="openLightbox(3, index)">
          <img :src="require('../' + image)" alt="">
        </div>
      </div>
      <div :slot="tabs[4]" class="gallery">
        <div v-for="(image, index) in $images['works2006-2012'].preview" :key="image.name" class="gallery-preview" @click="openLightbox(4, index)">
          <img :src="require('../' + image)" alt="">
        </div>
      </div>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: 'Peintures',
  data () {
    return {
      tabs: [
        '1980 - 1990',
        '1991 - 1985',
        '1996 - 1999',
        '2000 - 2005',
        '2006 - 2012'
      ],
      options: {
        showIcons: {
          diashow: false,
          fullScreen: false
        },
        showLightbox: false,
        localPath: true
      },
      imageArrayObjects: [
          this.$images['works1980-1990'].images,
          this.$images['works1991-1995'].images,
          this.$images['works1996-1999'].images,
          this.$images['works2000-2005'].images,
          this.$images['works2006-2012'].images
        ],
      currentImageIndex: [0, 0, 0, 0, 0],
      lightboxState: [false, false, false, false, false]
    }
  },
  created () {
    if (!this.$route.params.tab) this.$router.push({ name: 'Peintures', params: { tab: this.tabs[0].replace(/\s+/g, '-').toLowerCase() } })
  },
  methods: {
    setActiveTab (slug) {
      switch (slug) {
      case this.tabs[0].replace(/\s+/g, '-').toLowerCase():
        return this.$router.push({ name: 'Peintures', params: { tab: this.tabs[0].replace(/\s+/g, '-').toLowerCase() } })
      case this.tabs[1].replace(/\s+/g, '-').toLowerCase():
        return this.$router.push({ name: 'Peintures', params: { tab: this.tabs[1].replace(/\s+/g, '-').toLowerCase() } })
      case this.tabs[2].replace(/\s+/g, '-').toLowerCase():
        return this.$router.push({ name: 'Peintures', params: { tab: this.tabs[2].replace(/\s+/g, '-').toLowerCase() } })
      case this.tabs[3].replace(/\s+/g, '-').toLowerCase():
        return this.$router.push({ name: 'Peintures', params: { tab: this.tabs[3].replace(/\s+/g, '-').toLowerCase() } })
      case this.tabs[4].replace(/\s+/g, '-').toLowerCase():
        return this.$router.push({ name: 'Peintures', params: { tab: this.tabs[4].replace(/\s+/g, '-').toLowerCase() } })
      }
    },
    getActiveTab () {
      switch (this.$route.params.tab) {
      case this.tabs[0].replace(/\s+/g, '-').toLowerCase():
        return this.tabs[0].replace(/\s+/g, '-').toLowerCase()
      case this.tabs[1].replace(/\s+/g, '-').toLowerCase():
        return this.tabs[1].replace(/\s+/g, '-').toLowerCase()
      case this.tabs[2].replace(/\s+/g, '-').toLowerCase():
        return this.tabs[2].replace(/\s+/g, '-').toLowerCase()
      case this.tabs[3].replace(/\s+/g, '-').toLowerCase():
        return this.tabs[3].replace(/\s+/g, '-').toLowerCase()
      case this.tabs[4].replace(/\s+/g, '-').toLowerCase():
        return this.tabs[4].replace(/\s+/g, '-').toLowerCase()
      }
    },
    openLightbox (lightboxIndex, imageIndex) {
      this.$set(this.currentImageIndex, lightboxIndex, imageIndex)
      this.$set(this.lightboxState, lightboxIndex, true)
    },
    toggleCurrentLightBox (index, state) {
      this.lightboxState[index] = state
      this.$set(this.lightboxState, index, state)
    }
  }
}
</script>
